if (!customElements.get('social-details')) {
  class SocialDetails extends HTMLElement {
    constructor() {
      super();

      this.toggleOpen = this._toggleOpen.bind(this);
    }

    connectedCallback() {
      this.showButton = this.querySelector('[data-survey-show]');
      this.hideButton = this.querySelector('[data-survey-hide]');

      this.showButton?.addEventListener('click', this.toggleOpen);
      this.hideButton?.addEventListener('click', this.toggleOpen);
    }

    disconnectedCallback() {
      this.showButton?.removeEventListener('click', this.toggleOpen);
      this.hideButton?.removeEventListener('click', this.toggleOpen);
    }

    _toggleOpen() {      
      const isOpen = this.dataset.open === 'true';
      this.dataset.open = !isOpen;

      if (this.showButton) {
        this.showButton.hidden = !isOpen;
        this.showButton.setAttribute('aria-expanded', !isOpen ? 'true' : 'false');
      }
    }
  }

  customElements.define('social-details', SocialDetails);
}
